import type { RiskMatrixScore } from "@repo/shared/types";

export type ScoreRange = { min: number; max: number };

const DEFAULT_SCORE_RANGE: ScoreRange = { min: 1, max: 20 };

export function getScoreRange(matrixScores: RiskMatrixScore[] | undefined): ScoreRange {
  if (!matrixScores || matrixScores.length === 0) return DEFAULT_SCORE_RANGE;

  const values = matrixScores
    .map((s) => s.score)
    .filter((n): n is number => typeof n === "number" && Number.isFinite(n));

  if (values.length === 0) return DEFAULT_SCORE_RANGE;

  return { min: Math.min(...values), max: Math.max(...values) };
}
